var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPreloader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M7.99935 2.66667C5.05383 2.66667 2.66602 5.05448 2.66602 8C2.66602 10.9455 5.05383 13.3333 7.99935 13.3333C10.9449 13.3333 13.3327 10.9455 13.3327 8H11.9993C11.9993 10.2091 10.2085 12 7.99935 12C5.79021 12 3.99935 10.2091 3.99935 8C3.99935 5.79086 5.79021 4 7.99935 4V2.66667Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreloader);
export default __webpack_public_path__ + "static/media/preloader.29f6c0848c6cbbf6d6d62f98e2203b77.svg";
export { ForwardRef as ReactComponent };